import React from "react";

import styled from "styled-components/macro";

import LoadingSpinner from "components/PageLoader/Spinner";

const LoaderWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => false
})`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;

  ${({ fullscreen }) =>
    fullscreen &&
    `
    height: calc(100vh - 32px);
    width: 100%;
  `}

  span {
    color: var(--Neutral-100);
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
`;

const PageLoader = ({ color = "#A049FC", text = "Loading...", fullscreen }) => {
  return (
    <LoaderWrapper fullscreen={fullscreen}>
      <LoadingSpinner color={color} width="20" height="20" />
      <span>{text}</span>
    </LoaderWrapper>
  );
};

export default PageLoader;
